import MainPage from "./main.container";

export default MainPage;
